(function (module) {
  'use strict';
  module.directive('catchSrcError', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('error', function() {
            if (attrs.src != attrs.catchSrcError) {
                attrs.$set('src', attrs.catchSrcError);
            }
        });
      },
    };
  });
})(angular.module('obex'));



// WEBPACK FOOTER //
// ./client/js/directives/catchSrcError.directive.js